var exports = {
  "k": "x93eb46d8--880311--container",
};

module.exports = exports;
